import { render, staticRenderFns } from "./ArticlePTHeadlinesSection.vue?vue&type=template&id=09dbcd16&scoped=true&"
import script from "./ArticlePTHeadlinesSection.vue?vue&type=script&lang=ts&"
export * from "./ArticlePTHeadlinesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ArticlePTHeadlinesSection.vue?vue&type=style&index=0&id=09dbcd16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dbcd16",
  null
  
)

export default component.exports